<script setup>
import ViewerIcon from './ViewerIcon.vue'

defineProps({
  annotations: {
    type: Array,
    default: () => []
  },
  currentIndex: {
    type: Number,
    default: 0
  },
  visible: {
    type: Boolean,
    default: true
  },
  editing: Boolean,
  canEdit: Boolean,
  expanded: Boolean,
  callout: Boolean,
  saving: Boolean,
  saveProgress: {
    type: Object,
    default: null
  },
  uploadItems: {
    type: Array,
    default: () => []
  },
  menu: {
    type: Object,
    default: null
  }
})

defineEmits(['previous', 'next', 'toggle-visible', 'toggle-expanded', 'toggle-style', 'edit', 'snapshot', 'delete', 'close-menu', 'finish-edit'])
</script>

<template>
  <div v-if="editing" class="annotation-mode-tip"><i></i><span>标注编辑模式</span><small>点击模型表面添加标注</small></div>

  <nav v-if="annotations.length && !editing" class="annotation-navigator" aria-label="标注浏览">
    <button type="button" aria-label="上一个标注" @click="$emit('previous')"><ViewerIcon name="chevron-left" /></button>
    <button type="button" aria-label="下一个标注" @click="$emit('next')"><ViewerIcon name="chevron-right" /></button>
    <button
      type="button"
      :aria-label="callout ? '切换为数字标注' : '切换为折线面板标注'"
      :title="callout ? '切换为数字标注' : '切换为折线面板标注'"
      :class="{ active: callout }"
      @click="$emit('toggle-style')"
    ><ViewerIcon name="callout" /></button>
    <button
      type="button"
      :aria-label="expanded ? '收起全部标注内容' : '展开全部标注内容'"
      :title="expanded ? '收起全部' : '全部展开'"
      :class="{ active: expanded }"
      @click="$emit('toggle-expanded')"
    ><ViewerIcon name="panels" /></button>
    <button type="button" :aria-label="visible ? '隐藏标注' : '显示标注'" :class="{ active: visible }" @click="$emit('toggle-visible')"><ViewerIcon :name="visible ? 'eye' : 'eye-off'" /></button>
  </nav>

  <div v-if="editing" class="annotation-edit-actions">
    <button type="button" :disabled="saving" @click="$emit('finish-edit')">完成</button>
  </div>

  <div v-if="menu && editing" class="annotation-menu" :style="{ left: `${menu.x}px`, top: `${menu.y}px` }" @pointerdown.stop>
    <button type="button" @click="$emit('edit')"><ViewerIcon name="edit" />编辑</button>
    <button type="button" @click="$emit('snapshot')"><ViewerIcon name="camera" />更新视角</button>
    <button class="is-danger" type="button" @click="$emit('delete')"><ViewerIcon name="trash" />删除</button>
  </div>

  <div v-if="saving" class="annotation-saving" role="status">
    <span class="annotation-saving__spinner"></span>
    <div>
      <strong>{{ saveProgress?.phase === 'saving' ? '正在保存标注' : '正在上传标注附件' }}</strong>
      <small v-if="saveProgress?.total">{{ saveProgress.current || 0 }} / {{ saveProgress.total }}<template v-if="saveProgress?.progress"> · {{ saveProgress.progress }}%</template></small>
    </div>
    <div v-if="uploadItems.length" class="annotation-saving__files">
      <div v-for="item in uploadItems" :key="item.key" :class="`is-${item.status}`">
        <span>{{ item.name }}</span>
        <b>{{ item.status === 'failed' ? '已跳过' : item.status === 'saved' ? '完成' : `${item.progress}%` }}</b>
        <i><em :style="{ width: `${item.progress}%` }"></em></i>
        <small v-if="item.status === 'failed' && item.error">{{ item.error }}</small>
      </div>
    </div>
  </div>
</template>
